import { render, staticRenderFns } from "./CardPopupImg.vue?vue&type=template&id=b1aad952"
import script from "./CardPopupImg.vue?vue&type=script&lang=js"
export * from "./CardPopupImg.vue?vue&type=script&lang=js"
import style0 from "./CardPopupImg.vue?vue&type=style&index=0&id=b1aad952&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports